import o from "./_getNative.js";
import t from "./_root.js";
var a = o(t, "Map");
const e = a;
export {
  e as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_Map.js
// module id = 438
// module chunks = 41